import { createFileRoute, redirect } from "@tanstack/react-router";

// Moved to Engineering (ADR-044): old links and bookmarks keep working.
export const Route = createFileRoute("/_app/manufacturing/bom-structure")({
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/engineering/bom-structure", search: search as never, replace: true });
  },
});
